//#region Libraries
import { useRef, useState } from "react";
//#endregion
//#region Styles
import {
    Container,
    Content
} from "./styles";
//#endregion
//#region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import SelectBlock from "./components/SelectBlock/SelectBlock";
import InputDate from "./components/InputDate/InputDate";
//#endregion
//#region Utils
import {
    getDatePartsByMillis,
    getText, getToday
} from "./utils/helpers";
import { RequiredAsterisk, Row } from "components/styles";
import useAdjustFieldPopup from "utils/hooks/useAdjustFieldPopup";
//#endregion

const CustomDatePicker = ({
    label, placeholder = "Elige una fecha",
    onChange, value = -1,
    period = {
        min: getToday(),
        max: [3000, 1, 1]
    }, availableDays,
    error = false, errorText,
    disabled, required, width,
    popupMode = "floating"
}) => {
    const $containerRef = useRef();
    //#region States
    const [showSelectBlock, setShowSelectBlock] = useState(false);
    //#endregion
    useAdjustFieldPopup({
        $containerRef,
        showPopup: showSelectBlock,
        enabled: popupMode === "floating"
    });
    //#region Functions
    const toggleShowSelectBlock = () => {
        setShowSelectBlock(prev => !prev);
    }
    const changeValue = timestamp => {
        onChange && onChange(timestamp);
        toggleShowSelectBlock();
    }
    const getTextForInput = () => {
        if (value === -1)
            return null;
        return getText(getDatePartsByMillis(value));
    }
    const getClassName = () => {
        const classList = [];
        disabled && classList.push("disabled");
        return classList.join(" ");
    }
    //#endregion
    const className = getClassName();
    return (
        <Container
            ref={$containerRef}
            className={className}
            width={width}>
            {label &&
                <Row justifyContent="flex-start" gap="5px">
                    <label>{label}</label>
                    {required && <RequiredAsterisk>*</RequiredAsterisk>}
                </Row>}
            <Content
                className={className}
                tabIndex={0}
                onBlur={() => setShowSelectBlock(false)}>
                <InputDate
                    placeholder={placeholder}
                    disabled={disabled}
                    text={getTextForInput()}
                    error={error}
                    onClick={toggleShowSelectBlock} />
                <SelectBlock
                    show={showSelectBlock}
                    value={value}
                    handlerChangeValue={changeValue}
                    availableDays={availableDays}
                    period={period}
                    popupMode={popupMode} />
                <ErrorMessage
                    text={errorText}
                    error={error} />
            </Content>
        </Container>
    );
}

export default CustomDatePicker;
